/* Nourae Beauty - small progressive-enhancement layer.
   Nothing here is required for the page to work; it only adds
   reveal-on-scroll and the mobile order bar. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = document.querySelectorAll('.nr-rise:not(.is-in)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function orderTarget() {
    return (
      document.getElementById('nr-order') ||
      document.querySelector('[data-nr-order-anchor]') ||
      document.querySelector('.product-information') ||
      document.querySelector('main')
    );
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-nr-scroll]');
    if (!trigger) return;
    var target = orderTarget();
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  function initOrderBar() {
    var bar = document.querySelector('[data-nr-orderbar]');
    if (!bar) return;
    var target = document.getElementById('nr-order');

    function update() {
      var show = true;
      if (target) {
        var rect = target.getBoundingClientRect();
        show = !(rect.top < window.innerHeight * 0.85 && rect.bottom > 0);
      }
      if (window.scrollY < 260) show = false;
      bar.classList.toggle('is-visible', show);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function boot() {
    initReveal();
    initOrderBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
